import { useDraggable, useDroppable } from '@dnd-kit/core';
import React from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';

const DashboardComponent = ({ id, color, children, locked, onRemove, onEdit }) => {
    const { setNodeRef: setDropRef } = useDroppable({ id });
    const { attributes, listeners, setNodeRef: setDragRef, transform, isDragging } = useDraggable({ id, disabled: locked });
    const [isHovering, setIsHovering] = React.useState(false);

    const style = {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        transform: children && transform
            ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
            : undefined,
        background: color,
        border: children ? '1px solid #888' : '2px dashed #ccc',
        boxShadow: children ? '4px 4px 10px rgba(0, 0, 0, 0.2)' : '',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '24px',
        cursor: locked ? 'default' : children ? 'move' : 'default',
        zIndex: children && isDragging ? 1000 : 1,
        borderRadius: children ? '12px' : '',
        padding: '10px',
        opacity: children || isHovering || !locked ? 1 : 0.1,
    };

    const setRefs = (node) => {
        setDropRef(node);
        if (children) {
            setDragRef(node);
        }
    };

    return (
        <div
            ref={setRefs}
            style={style}
            {...(children && !locked ? listeners : {})}
            {...(children && !locked ? attributes : {})}
            onMouseEnter={() => !children && setIsHovering(true)}
            onMouseLeave={() => !children && setIsHovering(false)}
        >
            {children && !locked && (
                <>
                    <button
                        onClick={() => {
                            onEdit?.(id);
                        }}
                        onMouseDown={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                        }}
                        style={{
                            position: 'absolute',
                            top: '5px',
                            right: '40px',
                            backgroundColor: '#1976d2',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '30px',
                            height: '30px',
                            lineHeight: '1',
                            cursor: 'pointer',
                            zIndex: 10,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <EditIcon sx={{ fontSize: 16 }} />
                    </button>
                    <button
                        onClick={() => {
                            onRemove?.(id);
                        }}
                        onMouseDown={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                        }}
                        style={{
                            position: 'absolute',
                            top: '5px',
                            right: '5px',
                            backgroundColor: 'red',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '30px',
                            height: '30px',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            lineHeight: '1',
                            cursor: 'pointer',
                            zIndex: 10,
                        }}
                    >
                        X
                    </button>
                </>
            )}
            {children || (
                <AddCircleOutlineIcon
                    style={{
                        fontSize: 80,
                        color: '#999',
                        transition: 'opacity 0.3s ease',
                    }}
                />
            )}
        </div>
    );
};

export default DashboardComponent;
